const sortSymbol = '2Bfq9wtMSZ77LeWu7vJ+Qdf';
const zero = ['', '0', '00', '000', '0000', '00000', '000000', '0000000', '00000000', '000000000', '0000000000', '00000000000', '000000000000', '0000000000000', '00000000000000', '000000000000000', '0000000000000000', '00000000000000000', '000000000000000000', '0000000000000000000', '00000000000000000000'];
const f = a => a;
const MatchFloat = /([0-9]+\.?[0-9]*)/g;
const MatchInteger = /([0-9]+)/g;
export function textSort(a, conv = f, int = false) {
  let temp = {};
  for (let i = 0; i < a.length; i++) {
    const data = conv(a[i]);
    if (typeof data === 'number') {
      let t = String(data);
      if (t.length < 20) t = zero[20 - t.length] + t;
      temp[String(data)] = t;
    } else if (typeof data === 'string') {
      let t = data;
      const m = t.match(int ? MatchInteger : MatchFloat);
      if (m !== null) {
        t = t.replace(int ? MatchInteger : MatchFloat, sortSymbol);
        for (let i = 0; i < m.length; i++) {
          t = t.replace(sortSymbol, m[i].length < 20 ? zero[20 - m[i].length] + m[i] : m[i]);
        }
      }
      temp[String(data)] = t;
    } else {
      temp[String(data)] = String(data);
    }
  }
  a.sort((a, b) => {
    const sa = temp[String(conv(a))];
    const sb = temp[String(conv(b))];
    if (sa === sb) return 0;
    return sa > sb ? 1 : -1;
  });
  return a;
}

/**
 * @deprecated
 * 获取选值属性引用的选项
 * @param propData
 * @param dataIndex
 * @param dataType
 * @param matchConfig
 * @param creator
 * @param title 节点标题
 * @returns {*}
 */
export const getTempPropEnumOption = ({
  propData,
  dataIndex,
  dataType,
  matchConfig,
  creator,
  title = ''
}) => {
  return [];
};